import { Fragment, useEffect, useState } from "react";
import { axiosInstance } from "../../axios/axiosInstance";
import { useAuth } from "../../Context/AuthContext";

export const ProductStockStatus = ({ params }) => {
  const [stockStatus, setStockStatus] = useState(null);
  const { userId, companyId } = useAuth();
  useEffect(() => {
    var parameter = {
      prodid: String(params.productId ?? 0),
      userid: String(userId ?? 999),
      productCode: params.sku,
      type: "StockStatus",
    };
    axiosInstance
      .post("GetPriceTable", parameter)
      .then((response) => {
        if (response.data != "") {
          setStockStatus(response.data);
        }
      })
      .catch((error) => {
      });
  }, [params]);

  return <Fragment>{stockStatus && <span className="product-instock">{stockStatus}</span>}</Fragment>;
};
